<template>
  <div>
    <section class="section" v-if="loading">
      <div class="content has-text-grey has-text-centered">
        <p>Carregando itens do lote...</p>
      </div>
    </section>

    <section class="section" v-else-if="!proposals.length">
      <div class="content has-text-grey has-text-centered">
        <p>Nenhum item de lote cadastrado.</p>
      </div>
    </section>

    <b-table
      v-else
      class="table is-fullwidth lot-items-table"
      default-sort-direction="ASC"
      :data="proposals"
      :mobile-cards="false"
      scrollable
      sticky-header
    >
      <b-table-column centered sortable field="id" label="ID" v-slot="props">
        {{ props.row.identificador }}
      </b-table-column>

      <b-table-column centered label="Descrição" v-slot="props">
        {{ props.row.descricao }}
      </b-table-column>

      <b-table-column centered label="Marca/Modelo" v-slot="props">
        {{ formatBrandModel(props.row) }}
      </b-table-column>

      <b-table-column centered field="fabricado" label="Fabricado" v-slot="props">
        {{ props.row.fabricado }}
      </b-table-column>

      <b-table-column centered field="valor" label="Valor" v-slot="props">
        {{ props.row.valor ? formatValue(Number(props.row.valor)) : formatValue(0) }}
      </b-table-column>

      <b-table-column centered field="valorReadequado" label="Valor Readequado" v-slot="props">
        {{
          props.row.valorReadequado !== null && props.row.valorReadequado !== undefined
            ? formatValue(Number(props.row.valorReadequado))
            : '-'
        }}
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { formatarValor as formatValue } from '@/utils/format';

export default {
  name: 'ProposalsLotItemsList',
  props: {
    auctionId: {
      type: Number,
      required: true,
    },
    auctionItemId: {
      type: Number,
      required: true,
    },
    fornecedorId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      proposals: [],
      loading: false,
      formatValue,
    };
  },
  computed: {
    ...mapState('proposals', {
      batchItemProposals: 'batchItemProposals',
    }),
  },
  methods: {
    ...mapActions('proposals', ['fetchBatchItemProposals']),
    formatBrandModel(row) {
      if (row.marca) return row.marca;
      return row.marca || row.modelo || '-';
    },

    async carregarItensLote() {
      try {
        this.loading = true;
        await this.fetchBatchItemProposals({
          auctionId: this.auctionId,
          auctionItemId: this.auctionItemId,
          fornecedorId: this.fornecedorId,
        });

        this.proposals = this.batchItemProposals || [];
      } catch (error) {
        this.proposals = [];
        this.$alerta('Erro ao buscar itens do lote', 'is-danger');
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    fornecedorId: {
      immediate: true,
      deep: true,
      handler() {
        this.carregarItensLote();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 1500px) {
  .lot-items-table {
    font-size: 0.9rem;
  }
}

.lot-items-table ::v-deep .table-wrapper.has-sticky-header {
  height: auto;
  max-height: 40vh;
  overflow-y: auto;
}

.truncate-span {
  display: block;
  max-height: 60px;
  overflow-y: auto;
  white-space: normal;
  word-wrap: break-word;
  padding: 5px;
  max-width: 450px;
}
</style>
